import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Months' },
    { value: 2, label: 'Terms' },
    { value: 3, label: 'Alternate' },
  ],
});
